"use client"

import { PageLayout } from "@/components/page-layout"

export default function SupportPage() {
  return (
    <PageLayout>
      <div className="max-w-4xl mx-auto space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-foreground mb-2">Help & Support</h1>
          <p className="text-muted-foreground">
            Get help with the DLOM & Blockage Calculator
          </p>
        </div>

        <div className="p-6">
          <h2 className="text-xl font-semibold text-card-foreground mb-4">Overview</h2>
          <p className="text-card-foreground leading-relaxed">
            Please contact &quot;ashok.abbott@bizvalinc.com&quot; with any questions/comments/suggestions
          </p>
        </div>
      </div>
    </PageLayout>
  )
}
